const Constants = [
    {
        id: 1,
        logo: '/languages/reactjs.png',
        name: "ReactJS",
        description: "React is a free and open-source front-end JavaScript library for building user interfaces based on components. React can be used to develop single-page, mobile, or server-rendered applications with frameworks.",
    },
    {
        id: 2,
        logo: '/languages/nextjs.png',
        name: "NextJS",
        description: "Next.js is an open-source web development framework created by the private company Vercel providing React-based web applications with server-side rendering and static website generation.",
    },
    {
        id: 3,
        logo: '/languages/javascript.png',
        name: "JavaScript",
        description: "JavaScript is a scripting language used to develop web pages. Developed in Netscape, JS allows developers to create a dynamic and interactive web page to interact with visitors and execute complex actions.",
    },
    {
        id: 4,
        logo: '/languages/c++.png',
        name: "C++",
        description: "C++ is a popular programming language. C++ is used to create computer programs, and is one of the most used language in game development.C++ is a high-level, general-purpose programming language.",
    },
]

export default Constants